<div class="breadcrumbs">
  <span class="title" *ngIf="!isModifica">Gestione Emergenze <mat-icon style="vertical-align: middle;">
      keyboard_arrow_right</mat-icon> Dettaglio OCDPC </span>
  <span class="title" *ngIf="isModifica">Gestione Emergenze <mat-icon style="vertical-align: middle;">
      keyboard_arrow_right</mat-icon> Modifica OCDPC </span>
</div>
<hr>

<div class="titolo flex-display ">
  <div class="flex-display">
    <button mat-stroked-button class="pers" (click)="onNavigate('elenco-richieste')">
      <mat-icon style="vertical-align: middle;">keyboard_arrow_left</mat-icon>
    </button>

    <span class="h1 upp">Dettaglio OCDPC</span>
  </div>


  <div class="flex-row">
    <button *ngIf="!this.isNewRichiesta" mat-stroked-button color='basic' class="pers2 mleft" (click)="onNavigate('elenco-interventi')">
      INTERVENTI
    </button>
    <button mat-flat-button color='accent' class="pers3 mleft" (click)="onSaveEvent()" *ngIf="!isDettaglio">
      SALVA MODIFICHE
    </button>
  </div>
</div>



<div class="pers titles">
  <span class="title"> DATI OCDPC </span>
</div>


<div class="flex-form " [formGroup]="form">
  <div class="flex-row mt10">

    <div>
      <mat-form-field appearance="fill" color='accent'>
        <mat-label class="big">OCDPC *</mat-label>
        <input matInput [formControlName]="'ocdpc'">
      </mat-form-field>
      <mat-error *ngIf="this.form.controls.ocdpc.errors && this.form.controls.ocdpc.touched">
        <mat-error *ngIf="this.form.controls.ocdpc.errors.required">Campo obbligatorio
        </mat-error>
      </mat-error>
    </div>

    <mat-form-field appearance="legacy" color='accent' class="hidden">
      <input hidden matInput [formControlName]="'idRichiesta'">
    </mat-form-field>

    <mat-form-field appearance="legacy" color='accent' class="hidden">
      <input hidden matInput>
    </mat-form-field>
  </div>

</div>
<hr>
<div class="flex-form mt35" [formGroup]="form">
  <div class="flex-row">

    <div>
      <mat-form-field appearance="fill" color='accent'>
        <mat-label class="big">Informazioni *</mat-label>
        <input matInput [formControlName]="'informazioniOcdpc'">
      </mat-form-field>
      <mat-error *ngIf="this.form.controls.informazioniOcdpc.errors && this.form.controls.informazioniOcdpc.touched">
        <mat-error *ngIf="this.form.controls.informazioniOcdpc.errors.required">Campo obbligatorio
        </mat-error>
      </mat-error>
    </div>

    <div>
      <mat-form-field appearance="fill" color='accent'>
        <mat-label class="big">Territorio *</mat-label>
        <input matInput [formControlName]="'territorio'">
      </mat-form-field>
      <mat-error *ngIf="this.form.controls.territorio.errors && this.form.controls.territorio.touched">
        <mat-error *ngIf="this.form.controls.territorio.errors.required">Campo obbligatorio
        </mat-error>
      </mat-error>
    </div>

    <div>
      <mat-form-field appearance="fill" color='accent'>
        <mat-label class="big">Commissario *</mat-label>
        <input matInput [formControlName]="'commissario'">
      </mat-form-field>
      <mat-error *ngIf="this.form.controls.commissario.errors && this.form.controls.commissario.touched">
        <mat-error *ngIf="this.form.controls.commissario.errors.required">Campo obbligatorio
        </mat-error>
      </mat-error>
    </div>

  </div>

  <div class="flex-row mt10">

    <div>
      <mat-form-field color="accent" appearance="fill">
        <mat-label class="big">Data inizio *</mat-label>
        <input matInput [matDatepicker]="picker1" [formControlName]="'dataInizio'">
        <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
        <mat-datepicker #picker1></mat-datepicker>
      </mat-form-field>
      <mat-error *ngIf="this.form.controls.dataInizio.errors && this.form.controls.dataInizio.touched">
        <mat-error *ngIf="this.form.controls.dataInizio.errors.required">Campo obbligatorio
        </mat-error>
        <mat-error *ngIf="this.form.controls.dataInizio.errors.invalidData">Data inizio maggiore di data fine
        </mat-error>
      </mat-error>
    </div>

    <div>
      <mat-form-field color="accent" appearance="fill">
        <mat-label class="big">Data fine *</mat-label>
        <input matInput [matDatepicker]="picker2" [formControlName]="'dataFine'">
        <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
        <mat-datepicker #picker2></mat-datepicker>
      </mat-form-field>
      <mat-error *ngIf="this.form.controls.dataFine.errors && this.form.controls.dataFine.touched">
        <mat-error *ngIf="this.form.controls.dataFine.errors.required">Campo obbligatorio
        </mat-error>
      </mat-error>
    </div>

    <div>
      <mat-form-field appearance="fill" color='accent'>
        <mat-label class="big">Budget *</mat-label>
        <input matInput [formControlName]="'budget'">
      </mat-form-field>
      <mat-error *ngIf="this.form.controls.budget.errors && this.form.controls.budget.touched">
        <mat-error *ngIf="this.form.controls.budget.errors.required">Campo obbligatorio
        </mat-error>
        <mat-error *ngIf="this.form.controls.budget.errors.pattern">Il campo budget deve avere due cifre decimali
        </mat-error>
      </mat-error>
    </div>

  </div>

</div>

<div *ngIf="!isNewRichiesta">



  <div class="flex-row left">
    <button *ngIf="!isDettaglio" mat-flat-button color='accent' class="pers3" (click)="openAggiungiDpgrDialog()">
      AGGIUNGI DPGR
    </button>
  </div>


  <div class="mt10">
  <div class="mb10">
    <span class="dpgrtable">DPGR</span>
  </div>
  <mat-table [dataSource]="dataSource" matSort matSortActive="dataEvento" matSortDirection="desc"
    matSortDisableClear>

    <ng-container matColumnDef="dpgr">
      <mat-header-cell *matHeaderCellDef mat-sort-header> DPGR </mat-header-cell>
      <mat-cell [attr.data-label]="'DPGR'" *matCellDef="let element">
        {{element.dpgr}} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="descrizione">
      <mat-header-cell *matHeaderCellDef mat-sort-header> Descrizione </mat-header-cell>
      <mat-cell [attr.data-label]="'Descrizione evento'" *matCellDef="let element"> {{element.descrizione}} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="dataEvento">
      <mat-header-cell *matHeaderCellDef mat-sort-header> Data DPGR </mat-header-cell>
      <mat-cell [attr.data-label]="'Data DPGR'" *matCellDef="let element"> {{element.dataEvento}} </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

  </mat-table>

  <div *ngIf="emptyTableMessage">
    <mat-card class="emptyTable">
      <mat-card-content>
        <h6>Non ci sono risultati</h6>
      </mat-card-content>
    </mat-card>
  </div>

  <mat-paginator style="flex-wrap: wrap;" id='paginator' [pageSize]="risultatiPerPagina" [pageSizeOptions]="[3, 5, 10]">
  </mat-paginator>
</div>
</div>
